<template>
  <div id="app">
    <div :class="{isactive:fullLoaderCommon}" class="loader loader-default">
      <div id="loader-wrapper">
        <div id="loader">
        </div>
        <p v-if="$route.name === 'end'">Nous sauvegardons vos réponses...</p>
        <p v-else>Chargement...</p>
      </div>
    </div>
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'app',
    computed: {
      ...mapGetters(['fullLoaderCommon'])
    },
    created: function () {
      window.onresize = function (e) {
        // TODO recentrer le bloc central
      }
    }
  }
</script>

<style lang="scss">
  .loader {
    opacity:0;
    visibility: hidden;
    transition: all 1s;
    position:fixed;
    background-color:rgba(255,255,255,0.8);
    top:0;
    bottom:0;
    left:0;
    right:0;
    z-index: 1000;
    &.isactive {
      opacity:1;
      visibility: visible;
    }
  }
  @import 'src/assets/scss/app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue